/**
 * Garante que uma URL tenha o protocolo https://
 * Se a URL estiver vazia ou já tiver protocolo, retorna como está
 * Se não tiver protocolo, adiciona https:// automaticamente
 */
export function ensureHttps(url: string): string {
  if (!url || url.trim() === '') {
    return url;
  }

  const trimmedUrl = url.trim();

  // Se já tem protocolo http:// ou https://, retorna como está
  if (trimmedUrl.startsWith('http://') || trimmedUrl.startsWith('https://')) {
    return trimmedUrl;
  }

  // Adiciona https:// no início
  return `https://${trimmedUrl}`;
}
